import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { PrimaryButton, SecondaryButton } from '..';
import css from './TransactionPanel.css';
import { SECONDARY_BUTTON, PRIMARY_BUTTON } from '../../util/types';
import {
  TRANSITION_AUTO_CAPTURE_PAYMENT,
  TRANSITION_TRANSFERRED,
  TRANSITION_DISPUTE,
  TRANSITION_MARK_RETURN_ITEM,
  TRANSITION_REQUEST_EXTEND_BOOKING,
  TRANSITION_OFFER_EXTEND_BOOKING_DIRECTLY,
  TRANSITION_OFFER_EXTEND_BOOKING,
  TRANSITION_MARK_RETURN_ITEM_AFTER_OFFER_EXTEND_BOOKING,
  TRANSITION_DECLINE_EXTEND_BOOKING,
  TRANSITION_MARK_RETURN_ITEM_AFTER_REQUEST_EXTEND_BOOKING,
  ACTION_CUSTOMER_EXTEND_OFFER,
  TRANSITION_DISPUTE_AFTER_REQUEST_EXTEND_BOOKING,
  TRANSITION_DISPUTE_AFTER_OFFERED_EXTEND_BOOKING,
  TRANSITION_MARK_PENDING_PAYMENT,
  ACTION_MANUAL_RETRY_PAYMENT,
  ACTION_RETRY_WITH_CURRENT_CARD,
  TRANSITION_RESCHEDULE,
  TRANSITION_ACCEPT_RESCHEDULE,
  TRANSITION_CANCEL_RESCHEDULE,
  TRANSITION_CONFIRM_RESCHEDULE_ACCEPTANCE,
} from '../../util/customTransaction/mainRentalTransaction';
import { txLastTransition } from '../../util/transaction';
import {
  TRANSITION_EXTEND_PAYOUT_ADDITION_FEE,
  TRANSITION_EXTEND_MARK_RETURN_ITEM,
  TRANSITION_EXTEND_DISPUTE,
  TRANSITION_EXTEND_REQUEST_EXTEND_BOOKING,
  TRANSITION_EXTEND_REQUEST_PAYMENT_FREE,
  TRANSITION_EXTEND_MARK_RETURN_ITEM_AFTER_REQUEST_EXTEND_BOOKING,
  TRANSITION_EXTEND_OFFER_EXTEND_BOOKING_DIRECTLY,
  TRANSITION_EXTEND_OFFER_EXTEND_BOOKING,
  TRANSITION_EXTEND_MARK_RETURN_ITEM_AFTER_OFFER_EXTEND_BOOKING,
  TRANSITION_EXTEND_DECLINE_EXTEND_BOOKING,
  TRANSITION_EXTEND_DISPUTE_AFTER_EXTEND_REQUEST_EXTEND_BOOKING,
  TRANSITION_EXTEND_DISPUTE_AFTER_OFFERED_EXTEND_BOOKING,
  TRANSITION_EXTEND_RESCHEDULE,
  TRANSITION_EXTEND_FREE_RESCHEDULE,
  TRANSITION_EXTEND_TRANSFERRED,
  TRANSITION_EXTEND_FREE_TRANSFERRED,
  TRANSITION_EXTEND_REQUEST_PAYMENT,
  TRANSITION_ACCEPT_EXTEND_RESCHEDULE,
  TRANSITION_CANCEL_EXTEND_RESCHEDULE,
  TRANSITION_ACCEPT_EXTEND_FREE_RESCHEDULE,
  TRANSITION_CANCEL_EXTEND_FREE_RESCHEDULE,
  TRANSITION_CONFIRM_EXTEND_RESCHEDULE_ACCEPTANCE,
  TRANSITION_CONFIRM_EXTEND_FREE_RESCHEDULE_ACCEPTANCE,
  TRANSITION_EXTEND_ACCEPT,
  TRANSITION_EXTEND_DECLINE,
  TRANSITION_EXTEND_FREE_ACCEPT,
  TRANSITION_EXTEND_FREE_DECLINE,
} from '../../util/customTransaction/extendRentalTransaction';
import moment from 'moment';
import get from 'lodash/get';

// Allow extend booking after 2 days from booking end
const numberOfDaysForExtend = 3;

const checkAbilityToTransitExtendBooking = transaction => {
  const bookingEnd = get(transaction, 'booking.attributes.displayEnd', null);
  const formattedBookingEnd = moment(bookingEnd)
    .startOf('day')
    .toDate();
  const formattedToday = moment()
    .startOf('day')
    .toDate();
  const daysBetween = moment(formattedBookingEnd).diff(formattedToday, 'days');

  return daysBetween > -numberOfDaysForExtend;
};

const checkExtendBookingAlreadyStarted = transaction => {
  const bookingStart = get(transaction, 'booking.attributes.displayStart', null);
  const formattedBookingStart = moment(bookingStart)
    .startOf('day')
    .toDate();
  const formattedToday = moment()
    .startOf('day')
    .toDate();
  const daysBetween = moment(formattedBookingStart).diff(formattedToday, 'days');
  return daysBetween < 0;
}
export const getNextInteractableTransition = (transaction, isProvider) => {
  if (!transaction || !transaction.attributes || !transaction.attributes.lastTransition) return [];
  const lastTransition = txLastTransition(transaction);

  const isAbleToTransitExtendBooking = checkAbilityToTransitExtendBooking(transaction);

  switch (lastTransition) {
    case TRANSITION_RESCHEDULE: {
      if (!isProvider) {
        return [
          {
            type: PRIMARY_BUTTON,
            transitionName: TRANSITION_ACCEPT_RESCHEDULE,
          },
          {
            type: SECONDARY_BUTTON,
            transitionName: TRANSITION_CANCEL_RESCHEDULE,
          },
        ];
      } else {
        return [];
      }
    }
    case TRANSITION_ACCEPT_RESCHEDULE: {
      if (isProvider) {
        return [
          {
            type: PRIMARY_BUTTON,
            transitionName: TRANSITION_CONFIRM_RESCHEDULE_ACCEPTANCE,
          }
        ];
      } else {
        return [];
      }
    }
    case TRANSITION_AUTO_CAPTURE_PAYMENT:
    case TRANSITION_TRANSFERRED: {
      if (isProvider) {
        return [
          {
            type: PRIMARY_BUTTON,
            transitionName: TRANSITION_MARK_RETURN_ITEM,
          },
          {
            type: SECONDARY_BUTTON,
            transitionName: TRANSITION_DISPUTE,
          },
          isAbleToTransitExtendBooking
            ? {
              type: PRIMARY_BUTTON,
              transitionName: TRANSITION_OFFER_EXTEND_BOOKING_DIRECTLY,
            } : {},
        ];
      } else {
        return [];
      }
    }
    case TRANSITION_OFFER_EXTEND_BOOKING_DIRECTLY:
    case TRANSITION_OFFER_EXTEND_BOOKING: {
      if (isProvider) {
        return [
          {
            type: PRIMARY_BUTTON,
            transitionName: TRANSITION_MARK_RETURN_ITEM_AFTER_OFFER_EXTEND_BOOKING,
          },
          {
            type: SECONDARY_BUTTON,
            transitionName: TRANSITION_DISPUTE_AFTER_OFFERED_EXTEND_BOOKING,
          },
        ];
      } else if (isAbleToTransitExtendBooking) {
        return [
          {
            type: PRIMARY_BUTTON,
            transitionName: ACTION_CUSTOMER_EXTEND_OFFER,
          },
          {
            type: SECONDARY_BUTTON,
            transitionName: TRANSITION_DECLINE_EXTEND_BOOKING,
          },
        ];
      }
    }
    case TRANSITION_DECLINE_EXTEND_BOOKING: {
      if (isProvider) {
        return [
          {
            type: PRIMARY_BUTTON,
            transitionName: TRANSITION_MARK_RETURN_ITEM_AFTER_OFFER_EXTEND_BOOKING,
          },
          {
            type: SECONDARY_BUTTON,
            transitionName: TRANSITION_DISPUTE_AFTER_OFFERED_EXTEND_BOOKING,
          },
        ];
      } else {
        return [];
      }
    }
    case TRANSITION_REQUEST_EXTEND_BOOKING: {
      if (isProvider) {
        return [
          isAbleToTransitExtendBooking
            ?
            {
              type: PRIMARY_BUTTON,
              transitionName: TRANSITION_OFFER_EXTEND_BOOKING,
            }
            : {},
          {
            type: PRIMARY_BUTTON,
            transitionName: TRANSITION_MARK_RETURN_ITEM_AFTER_REQUEST_EXTEND_BOOKING,
          },
          {
            type: SECONDARY_BUTTON,
            transitionName: TRANSITION_DISPUTE_AFTER_REQUEST_EXTEND_BOOKING,
          },
        ];
      }
      return [];
    }
    case TRANSITION_MARK_PENDING_PAYMENT:
      {
        if (!isProvider) {
          return [
            {
              type: PRIMARY_BUTTON,
              transitionName: ACTION_MANUAL_RETRY_PAYMENT,
            },
            {
              type: PRIMARY_BUTTON,
              transitionName: ACTION_RETRY_WITH_CURRENT_CARD,
            },
          ];
        }
      }
      return [];
    default:
      return [];
  }
};

export const getExtendNextInteractableTransition = (lastExTransaction, isProvider) => {
  if (
    !lastExTransaction ||
    !lastExTransaction.attributes ||
    !lastExTransaction.attributes.lastTransition
  )
    return [];

  const lastTransition = txLastTransition(lastExTransaction);

  const isAbleToTransitExtendBooking = checkAbilityToTransitExtendBooking(lastExTransaction);
  const isExtendBookingAlreadyStarted = checkExtendBookingAlreadyStarted(lastExTransaction);

  switch (lastTransition) {
    case TRANSITION_EXTEND_TRANSFERRED:
    case TRANSITION_EXTEND_FREE_TRANSFERRED: {
      if (isProvider) {
        return [
          isExtendBookingAlreadyStarted ?
            {
              type: PRIMARY_BUTTON,
              transitionName: TRANSITION_EXTEND_MARK_RETURN_ITEM,
            } : {},
          isExtendBookingAlreadyStarted ? {
            type: SECONDARY_BUTTON,
            transitionName: TRANSITION_EXTEND_DISPUTE,
          } : {},
          isAbleToTransitExtendBooking
            ?
            {
              type: PRIMARY_BUTTON,
              transitionName: TRANSITION_EXTEND_OFFER_EXTEND_BOOKING_DIRECTLY,
            }
            : {},
        ];
      } else {
        return [];
      }
    }
    case TRANSITION_EXTEND_REQUEST_EXTEND_BOOKING: {
      if (isProvider) {
        return [
          isAbleToTransitExtendBooking
            ?
            {
              type: PRIMARY_BUTTON,
              transitionName: TRANSITION_EXTEND_OFFER_EXTEND_BOOKING,
            }
            : {},
          {
            type: PRIMARY_BUTTON,
            transitionName: TRANSITION_EXTEND_MARK_RETURN_ITEM_AFTER_REQUEST_EXTEND_BOOKING,
          },
          {
            type: SECONDARY_BUTTON,
            transitionName: TRANSITION_EXTEND_DISPUTE_AFTER_EXTEND_REQUEST_EXTEND_BOOKING,
          },
        ];
      }
      return [];
    }
    case TRANSITION_EXTEND_OFFER_EXTEND_BOOKING_DIRECTLY:
    case TRANSITION_EXTEND_OFFER_EXTEND_BOOKING: {
      if (isProvider) {
        return [
          {
            type: PRIMARY_BUTTON,
            transitionName: TRANSITION_EXTEND_MARK_RETURN_ITEM_AFTER_OFFER_EXTEND_BOOKING,
          },
          {
            type: SECONDARY_BUTTON,
            transitionName: TRANSITION_EXTEND_DISPUTE_AFTER_OFFERED_EXTEND_BOOKING,
          },
        ];
      } else if (isAbleToTransitExtendBooking) {
        return [
          {
            type: PRIMARY_BUTTON,
            transitionName: ACTION_CUSTOMER_EXTEND_OFFER,
          },
          {
            type: SECONDARY_BUTTON,
            transitionName: TRANSITION_EXTEND_DECLINE_EXTEND_BOOKING,
          },
        ];
      }
    }
    case TRANSITION_EXTEND_DECLINE_EXTEND_BOOKING:
      {
        if (isProvider) {
          return [
            {
              type: PRIMARY_BUTTON,
              transitionName: TRANSITION_EXTEND_MARK_RETURN_ITEM_AFTER_OFFER_EXTEND_BOOKING,
            },
          ];
        }
      }
      return [];
    case TRANSITION_EXTEND_REQUEST_PAYMENT: {
      if (isProvider) {
        return [
          {
            type: PRIMARY_BUTTON,
            transitionName: TRANSITION_EXTEND_ACCEPT,
          },
          {
            type: PRIMARY_BUTTON,
            transitionName: TRANSITION_EXTEND_RESCHEDULE,
          },
          {
            type: SECONDARY_BUTTON,
            transitionName: TRANSITION_EXTEND_DECLINE,
          },
        ];
      } else {
        return [];
      }
    }
    case TRANSITION_EXTEND_REQUEST_PAYMENT_FREE: {
      if (isProvider) {
        return [
          {
            type: PRIMARY_BUTTON,
            transitionName: TRANSITION_EXTEND_FREE_ACCEPT,
          },
          {
            type: PRIMARY_BUTTON,
            transitionName: TRANSITION_EXTEND_FREE_RESCHEDULE,
          },
          {
            type: SECONDARY_BUTTON,
            transitionName: TRANSITION_EXTEND_FREE_DECLINE,
          },
        ];
      } else {
        return [];
      }
    }
    case TRANSITION_EXTEND_RESCHEDULE:
      {
        if (!isProvider) {
          return [
            {
              type: PRIMARY_BUTTON,
              transitionName: TRANSITION_ACCEPT_EXTEND_RESCHEDULE,
            },
            {
              type: SECONDARY_BUTTON,
              transitionName: TRANSITION_CANCEL_EXTEND_RESCHEDULE,
            },
          ];
        }
      }
      return [];
    case TRANSITION_EXTEND_FREE_RESCHEDULE:
      {
        if (!isProvider) {
          return [
            {
              type: PRIMARY_BUTTON,
              transitionName: TRANSITION_ACCEPT_EXTEND_FREE_RESCHEDULE,
            },
            {
              type: SECONDARY_BUTTON,
              transitionName: TRANSITION_CANCEL_EXTEND_FREE_RESCHEDULE,
            },
          ];
        }
      }
      return [];
    case TRANSITION_ACCEPT_EXTEND_RESCHEDULE: {
      if (isProvider) {
        return [
          {
            type: PRIMARY_BUTTON,
            transitionName: TRANSITION_CONFIRM_EXTEND_RESCHEDULE_ACCEPTANCE,
          }
        ];
      } else {
        return [];
      }
    }
    case TRANSITION_ACCEPT_EXTEND_FREE_RESCHEDULE: {
      if (isProvider) {
        return [
          {
            type: PRIMARY_BUTTON,
            transitionName: TRANSITION_CONFIRM_EXTEND_FREE_RESCHEDULE_ACCEPTANCE,
          }
        ];
      } else {
        return [];
      }
    }
    default:
      return [];
  }
};

const getTransitButtonLabelId = transition => {
  switch (transition) {
    case TRANSITION_ACCEPT_RESCHEDULE:
      return 'TransitActionButtonMaybe.transitionAcceptReschedule';
    case TRANSITION_CANCEL_RESCHEDULE:
      return 'TransitActionButtonMaybe.transitionCancelReschedule';
    case TRANSITION_CONFIRM_RESCHEDULE_ACCEPTANCE:
      return 'TransitActionButtonMaybe.transitionConfirmRescheduleAcceptance';
    case TRANSITION_TRANSFERRED:
      return 'TransitActionButtonMaybe.transitionSendItem';
    case TRANSITION_MARK_RETURN_ITEM:
      return 'TransitActionButtonMaybe.transitionMarkReturnItem';
    case TRANSITION_DISPUTE:
      return 'TransitActionButtonMaybe.transitionDispute';
    case TRANSITION_REQUEST_EXTEND_BOOKING:
      return 'TransitActionButtonMaybe.transitionRequestExtendBooking';
    case TRANSITION_MARK_RETURN_ITEM_AFTER_OFFER_EXTEND_BOOKING:
      return 'TransitActionButtonMaybe.transitionMarkReturnItemAfterOfferExtendBooking';
    case TRANSITION_EXTEND_DECLINE_EXTEND_BOOKING:
    case TRANSITION_DECLINE_EXTEND_BOOKING:
      return 'TransitActionButtonMaybe.transitionDeclineExtendBooking';
    case TRANSITION_MARK_RETURN_ITEM_AFTER_REQUEST_EXTEND_BOOKING:
      return 'TransitActionButtonMaybe.transitionMarkReturnItemAfterRequestExtendBooking';
    case TRANSITION_OFFER_EXTEND_BOOKING_DIRECTLY:
    case TRANSITION_OFFER_EXTEND_BOOKING:
      return 'TransitActionButtonMaybe.transitionOfferExtendBooking';
    case ACTION_CUSTOMER_EXTEND_OFFER:
      return 'TransitActionButtonMaybe.actionCustomerExtendOffer';
    case TRANSITION_EXTEND_MARK_RETURN_ITEM:
      return 'TransitActionButtonMaybe.transitionExtendMarkReturnItem';
    case TRANSITION_EXTEND_DISPUTE:
      return 'TransitActionButtonMaybe.transitionExtendDispute';
    case TRANSITION_EXTEND_REQUEST_EXTEND_BOOKING:
      return 'TransitActionButtonMaybe.transitionExtendRequestExtendBooking';
    case TRANSITION_EXTEND_OFFER_EXTEND_BOOKING_DIRECTLY:
    case TRANSITION_EXTEND_OFFER_EXTEND_BOOKING:
      return 'TransitActionButtonMaybe.transitionExtendOfferExtendBooking';
    case TRANSITION_EXTEND_MARK_RETURN_ITEM_AFTER_REQUEST_EXTEND_BOOKING:
      return 'TransitActionButtonMaybe.transitionExtendMarkReturnItemAfterRequestExtendBooking';
    case TRANSITION_EXTEND_MARK_RETURN_ITEM_AFTER_OFFER_EXTEND_BOOKING:
      return 'TransitActionButtonMaybe.transitionExtendMarkReturnItemAfterOfferExtendBooking';
    case TRANSITION_DISPUTE_AFTER_REQUEST_EXTEND_BOOKING:
      return 'TransitActionButtonMaybe.transitionDisputeAfterRequestExtendBooking';
    case TRANSITION_EXTEND_DISPUTE_AFTER_EXTEND_REQUEST_EXTEND_BOOKING:
      return 'TransitActionButtonMaybe.transitionExtendDisputeAfterExtendRequestExtendBooking';
    case TRANSITION_DISPUTE_AFTER_OFFERED_EXTEND_BOOKING:
      return 'TransitActionButtonMaybe.transitionDisputeAfterOfferedExtendBooking';
    case TRANSITION_EXTEND_DISPUTE_AFTER_OFFERED_EXTEND_BOOKING:
      return 'TransitActionButtonMaybe.transitionExtendDisputeAfterOfferedExtendBooking';
    case ACTION_MANUAL_RETRY_PAYMENT:
      return 'TransitActionButtonMaybe.actionManualRetryPayment';
    case ACTION_RETRY_WITH_CURRENT_CARD:
      return 'TransitActionButtonMaybe.actionRetryWithCurrentCard';
    case TRANSITION_EXTEND_ACCEPT:
      return 'TransitActionButtonMaybe.transitionExtendAccept';
    case TRANSITION_EXTEND_DECLINE:
      return 'TransitActionButtonMaybe.transitionExtendDecline';
    case TRANSITION_EXTEND_FREE_ACCEPT:
      return 'TransitActionButtonMaybe.transitionExtendAccept';
    case TRANSITION_EXTEND_FREE_DECLINE:
      return 'TransitActionButtonMaybe.transitionExtendDecline';
    case TRANSITION_EXTEND_RESCHEDULE:
      return 'TransitActionButtonMaybe.transitionExtendReschedule';
    case TRANSITION_EXTEND_FREE_RESCHEDULE:
      return 'TransitActionButtonMaybe.transitionExtendReschedule';
    case TRANSITION_ACCEPT_EXTEND_RESCHEDULE:
      return 'TransitActionButtonMaybe.transitionAcceptReschedule';
    case TRANSITION_ACCEPT_EXTEND_FREE_RESCHEDULE:
      return 'TransitActionButtonMaybe.transitionAcceptReschedule';
    case TRANSITION_CANCEL_EXTEND_RESCHEDULE:
      return 'TransitActionButtonMaybe.transitionCancelReschedule';
    case TRANSITION_CANCEL_EXTEND_FREE_RESCHEDULE:
      return 'TransitActionButtonMaybe.transitionCancelReschedule';
    case TRANSITION_CONFIRM_EXTEND_RESCHEDULE_ACCEPTANCE:
      return 'TransitActionButtonMaybe.transitionConfirmRescheduleAcceptance';
    case TRANSITION_CONFIRM_EXTEND_FREE_RESCHEDULE_ACCEPTANCE:
      return 'TransitActionButtonMaybe.transitionConfirmRescheduleAcceptance';
    default:
      return null;
  }
};

const getTransitErrorLabelId = transition => {
  switch (transition) {
    default:
      return null;
  }
};

// Functional component as a helper to build ActionButtons for
// provider/customer when can be change state
export const TransitActionButtonsMaybe = props => {
  const {
    className,
    rootClassName,
    transaction,
    transitInProgress,
    transitError,
    onTransit,
    transitions,
    customActions,
    customErrorMessage,
  } = props;

  const buttonsDisabled = transitInProgress;

  const transitErrorMessage = customErrorMessage ? (
    <p className={css.actionError}>{customErrorMessage}</p>
  ) : transitError ? (
    <p className={css.actionError}>
      {/* For future */}
      {/* getTransitErrorLabelId(transitions[0].transitionName) */}
      <FormattedMessage id={'TransitActionButtonMaybe.errorMessage'} />
    </p>
  ) : null;

  const classes = classNames(rootClassName || css.actionButtons, className);

  return (
    <div className={classes}>
      <div className={css.actionErrors}>{transitErrorMessage}</div>
      <div className={css.transitionActionButtonWrapper}>
        {transitions.map((transition, index) => {
          const { type, transitionName } = transition;
          const buttonOnTransit = () => {
            const customAction = customActions && customActions[transitionName];
            if (customAction) {
              customAction({
                transaction,
                transitionName,
              });
            } else {
              onTransit(transaction.id, transitionName);
            }
          };

          if (type === PRIMARY_BUTTON) {
            return (
              <div key={index} className={css.girdItem}>
                <PrimaryButton
                  inProgress={transitInProgress}
                  disabled={buttonsDisabled}
                  onClick={buttonOnTransit}
                >
                  <FormattedMessage id={getTransitButtonLabelId(transitionName)} />
                </PrimaryButton>
              </div>
            );
          }
          if (type === SECONDARY_BUTTON) {
            return (
              <div key={index} className={css.girdItem}>
                <SecondaryButton
                  inProgress={transitInProgress}
                  disabled={buttonsDisabled}
                  onClick={buttonOnTransit}
                >
                  <FormattedMessage id={getTransitButtonLabelId(transitionName)} />
                </SecondaryButton>
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
};

export default TransitActionButtonsMaybe;
